'use strict';

/**
 *
 * @name: spinner
 *
 */

import DirectiveTemplate from './nn-spinner.directive.html';
import './nn-spinner.directive.scss';

function SpinnerDirective() {

  'ngInject';

  return {
    restrict: 'EA', // TODO: leave only Element
    replace: true,
    transclude: false,
    template: DirectiveTemplate,
  };
}

export default SpinnerDirective;



// WEBPACK FOOTER //
// ./app/components/nn-generic-directives/nn-spinner/nn-spinner.directive.js